export default {
  title: 'גילוי נאות לשיווק פנסיוני',
  content: `
    <p>
      פולאריס סוכנות לביטוח פנסיוני (2018) בע"מ הינה
      סוכנות ביטוח בבעלות פרטית, אשר עומדת בקשר עסקי עם הגופים המוסדיים המפורטים להלן.
      לצורך שיווק מוצרים פנסיוניים קיימת זיקה, כהגדרתה בחוק הפיקוח על שירותים פיננסים
      (עיסוק בייעוץ פנסיוני ושיווק פנסיוני) התשס"ה-2005, בין פולאריס סוכנות לביטוח פנסיוני
      (2018) בע"מ וגופים אלה לבין המוצרים הפנסיוניים המשווקים על ידי תמורה.
    </p>

    <p>
      <h3>חברות ביטוח</h3>
      כלל פנסיה וגמל בע"מ, מנורה מבטחים פנסיה בע"מ, הראל ניהול קרנות פנסיה בע"מ,
      מגדל מקפת קרנות פנסיה וקופות גמל בע"מ, הפניקס פנסיה וגמל בע"מ,
      מיטב דש גמל ופנסיה בע"מ*, אלטשולר שחם קופות גמל בע"מ*, פסגות פנסיה וגמל בע"מ*,
    </p>

    <p>
      <h3>קרנות פנסיה</h3>
      כלל פנסיה וגמל בע"מ, מנורה מבטחים פנסיה בע"מ, הראל ניהול קרנות פנסיה בע"מ,
      מגדל מקפת קרנות פנסיה וקופות גמל בע"מ, הפניקס פנסיה וגמל בע"מ,
      מיטב דש גמל ופנסיה בע"מ*, אלטשולר שחם קופות גמל בע"מ*, פסגות פנסיה וגמל בע"מ*,
    </p>

    <p>
      <h3>קופות גמל</h3>
      כלל פנסיה וגמל בע"מ, מיטב דש גמל ופנסיה בע"מ, פסגות פנסיה וגמל בע"מ,
      הפניקס-אקסלנס נשואה גמל ופנסיה בע"מ, ילין לפידות ניהול קופות גמל בע"מ,
      אלטשולר שחם קופות גמל בע"מ, מנורה מבטחים גמל בע"מ, הראל גמל והשתלמות בע"מ,
      מגדל מקפת קרנות פנסיה וקופות גמל בע"מ, מור קופות גמל בע"מ.
    </p>

    <p>
      <h3>קרנות השתלמות</h3>
      כלל פנסיה וגמל בע"מ, מיטב דש גמל ופנסיה בע"מ, ילין לפידות ניהול קופות
      גמל בע"מ, אלטשולר שחם קופות גמל בע"מ, הפניקס -אקסלנס נשואה גמל ופנסיה
      בע"מ, מגדל מקפת קרנות פנסיה וקופות גמל בע"מ, פסגות פנסיה וגמל בע"מ,
      הראל גמל והשתלמות בע"מ, מור קופות גמל בע"מ, מנורה מבטחים גמל בע"מ.
    </p>
  `,
};
